import React from 'react'
import { formatUrl } from '../../util/formatUtils'
import { locationRoute } from '../../routes/routes'
import { Link, withRouter } from 'react-router-dom'
import { Action } from '@foodsby/nutrient'

export const NavPageLinks = ({ pageName, history, locationId }) => (
  <ul>
    <li>{pageName}</li>
    <li>
      <Link to={formatUrl(locationRoute.path, { locationId })}>
        <Action>
          <i className="icon-home" /> My Home
        </Action>
      </Link>
    </li>
    <li>
      <Action
        className="go-back"
        onClick={history.goBack}
        style={{ marginBottom: '16px', marginTop: '16px' }}
      >
        <i className="icon-back" /> Back
      </Action>
    </li>
  </ul>
)

export default withRouter(NavPageLinks)
